import React, { ReactElement } from 'react';
import './SelectProductItem.scss';
import { Product } from '../../../../Models/Product';
import { ReadOrPurchaseButton } from '../../Series/ComicInfo/Volume/VolumeItem';
import { Cart } from '../../../../Models/Cart';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { AddToCartAction, CartAtom, DeductFromCartAction, UpdatingCartAtom } from '../../../../store/CartStore';
import { ReactComponent as SvgArrow } from '../../../Assets/icons/ARROW-SHARP.svg';
import { CheckoutOverlayVisible, LoginOverlayVisible, LoginType, LoginTypeStore } from '../../../../store/OverlayStore';
import Log from '../../../Services/Logger';
import { Variant } from '../../../../Models/Product/Variant';
import { CartItem, VariantType } from '../../../../Models/CartItem';
import { AccountInfoAtom, LoginStatusAtom } from '../../../../store/AccountStore';
import { ReactComponent as PlusIcon } from '../../../Assets/icons/PLUS.svg';
import { ReactComponent as MinusIcon } from '../../../Assets/icons/MINUS.svg';
import KodanshaArrow from '../../../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import apiClient from '../../../../API/InkyAPI';
import AnalyticsEvent from '../../../../Models/Analytics/AnalyticsEvent';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from '../../../../store/AnalyticsStore';
import { isTheVolumeInCart, isTheVolumeInCartDigital } from '../../../../utils/utils';


interface SelectProductItemProps {
    title: string;
    text: string;
    product: Product;
    variant?: Variant;
}


const SelectProductItem = ({
                               text,
                               title,
                               product,
                                variant
                           }: SelectProductItemProps): ReactElement => {
    const addToCart = useSetAtom(AddToCartAction);
    const accountInfo = useAtomValue(AccountInfoAtom);
    const sessionId = useAtomValue(AnalyticsIdAtom);
    const analyticsUserProxy= useAtomValue(AnalyticsUserProxyAtom);
    const updatingCart = useAtomValue(UpdatingCartAtom);

    const defaultVariant = product.getDefaultVariant();
    const sale = defaultVariant?.priceType === 'Paid' && defaultVariant?.isOnSale;
    const cartAtom = useAtomValue(CartAtom);


    async function trackAddToCart(product): Promise<void> {
        const productId = product.id;
        await apiClient.sendEvent(accountInfo,new AnalyticsEvent(sessionId.toString(), 'ADD_CART', window.location.pathname, productId, analyticsUserProxy.toString()))
            .then(res => {
                console.log(res);
            }).catch(e => {
                console.error(e);
            });
    }
    async function addItemToCart(product, variant?: Variant) {
        if(updatingCart) {
            return;
        }
        if(variant){
            await addToCart({ productId: product.id, variantId: variant.id });
        } else {
            await addToCart({ productId: product.id, variantId: product.variants[0].id });
        }

        await trackAddToCart(product);
    }

    function PriceOrOwnershipStatus(): JSX.Element {

        if(variant?.type == VariantType.Print){

            switch (variant.priceType) {
                case "Paid":
                    if(variant.isOnSale) {
                        return <div className='product-price-wrapper'>
                            <span className='product-select-p-item-info-discount'>${variant.fullPrice.toFixed(2)}</span>
                            <span className='product-select-p-item-info-price'>${variant.discountPrice.toFixed(2)}</span>
                        </div>
                    }
                    return <span className='product-select-p-item-info-price'>{variant.price?.toFormat()}</span>
                case "Free":
                    return <span className='product-select-p-item-info-price'>Free</span>
                case "NotForSale":
            }
        }

        if(product.readable.isOwned) {
            return <span className='product-select-p-item-info-price'>In Library</span>
        }

        const defaultVariant = product.getDefaultVariant();
        Log.info("................" + defaultVariant.price?.toFormat(), defaultVariant);
        console.log(defaultVariant);
        switch (defaultVariant.priceType) {
            case "Paid":
            case "FreeToReadAndPurchaseble":
            case "FreeToReadForRegisteredAndPurchaseble":
                if(defaultVariant.isOnSale) {
                    return <div className='product-price-wrapper'>
                        <span className='product-select-p-item-info-discount'>${defaultVariant.fullPrice.toFixed(2)}</span>
                        <span className='product-select-p-item-info-price'>${defaultVariant.discountPrice.toFixed(2)}</span>
                    </div>
                }
                return <span className='product-select-p-item-info-price'>{defaultVariant.price?.toFormat()}</span>
            case "Free":
                return <span className='product-select-p-item-info-price'>Free</span>
            case "NotForSale":
        }

        return null;
    }

    function PurchaseProductSection() {
        const cart = useAtomValue(AddToCartAction);
        const updatingCart = useAtomValue(UpdatingCartAtom);
        const setCheckoutOverlay = useSetAtom(CheckoutOverlayVisible);
        const removeFromCart = useSetAtom(DeductFromCartAction);
        const [isLoggedIn] = useAtom(LoginStatusAtom);
        const SetLoginOverlay = useSetAtom(LoginOverlayVisible);
        const [, deductFromCartAction] = useAtom(DeductFromCartAction);
        const [, addToCartAction] = useAtom(AddToCartAction);

        function hasPhysical() {
            return cart && cart.containsProductVariantType(VariantType.Print);
        }

        const onCheckoutClicked = (): void => {
            if(isLoggedIn === "LoggedIn"){
                setCheckoutOverlay(true);
            } else {
                LoginTypeStore.setLoginType(LoginType.Checkout);
                SetLoginOverlay(true)
            }
        };

        const onCartRemoveClicked = async () => {
            if(!updatingCart) {
                await removeFromCart({ productId: product.id, variantId: variant.id });
            }
        };
        function findAmount(productID, variantId): number {
            if(cart ==null) return ;
            return (cart as Cart).cartItems.filter(x => x.product.id == productID && x.variant.id == variantId).length;
        }
        function isLessThanOrderAmountIfOrderAmount(){
            return !(variant.cartLimit === undefined ||
                variant.cartLimit === null ||
                findAmount(product.id, variant.id) < variant.cartLimit)
        }
        if(variant?.isInStock ===false) {
            return (
                <KodanshaArrow
                    styles='product-select-p-item-checkout-out-of-stock-button'
                    bold
                    text={"OUT OF STOCK"}
                    active={false}
                    withArrow={false}
                    ignoreActive

                />
            ); //styles={props.className}
        }

        if(cart && (cart as Cart).containsProductVariant(product, variant)) {
            if(variant.type ==="Print"){
                return <div className='remove-from-cart-wrapper'>
                    <div className='remove-from-cart-inner-wrapper quantity-wrapper'>
                        <span className='product-added-text'>Product added to cart</span>
                        <div className={'amount'}>
                            <span className='quantity'>Quantity</span>
                            <div className='quantity-controller'>
                                <button
                                    className='button-no-style'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        deductFromCartAction({ productId: product.id, variantId: variant.id });
                                    }
                                    }>
                                    <MinusIcon width={15} />
                                </button>

                                {findAmount(product.id, variant.id)}

                                {isLessThanOrderAmountIfOrderAmount() ?
                                    <span className='max-quantity'>MAX</span>
                                    : <button
                                    className='button-no-style'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        addToCartAction({ productId: product.id, variantId: variant.id });
                                    }
                                    }
                                    style={{ fill: (isLessThanOrderAmountIfOrderAmount()) ? 'grey' : '' }}
                                    disabled={isLessThanOrderAmountIfOrderAmount()}

                                >
                                    <PlusIcon width={15} />
                                </button>}

                            </div>
                        </div>
                    </div>

                    <div className='remove-from-cart-inner-wrapper'>
                        <div className='checkout-button-wrapper' onClick={onCheckoutClicked}>
                                <span className='checkout-button-text'>
                                    Checkout
                                </span>
                            <SvgArrow fill={'white'} className={'checkout-button-icon'} />
                        </div>
                    </div>
                </div>
            }

            return (
                <div className='remove-from-cart-wrapper'>
                    <div className='remove-from-cart-inner-wrapper'>
                        <span className='product-added-text'>Product added to cart</span>
                        <span onClick={onCartRemoveClicked} className='product-remove-text'>Remove</span>
                    </div>

                    <div className='remove-from-cart-inner-wrapper'>
                        <div className='checkout-button-wrapper' onClick={onCheckoutClicked}>
                                <span className='checkout-button-text'>
                                    Checkout
                                </span>
                            <SvgArrow fill={'white'} className={'checkout-button-icon'} />
                        </div>
                    </div>
                </div>
            );
        }

        function renderBuyButtonText(buttonText: string, variant?: Variant) {

            return (
                <span className='details-text-product'
                      onClick={() => addItemToCart(product, variant).then(() => {
                          Log.info('Item added');
                      }).catch((e) => {
                          Log.error('Item not added', e);
                      })}
                >
                {buttonText}
                </span>

            );
        }

        /**
         * Only return add to cart text if needed
         * @constructor
         */
        function AddToCartTextIfPurchasableAndNotPaid() {
            if(variant?.type === VariantType.Print|| variant.priceType ==="Paid"){
                return<></>
            }
            //will be digital variant due to previous if statement
            if (Variant.IsPurchaseable(variant) && !product.readable.isOwned) {
                return (<div className='new-state-add-to-cart'>
                    <span className='new-state-add-to-cart-text'>
                        Product is currently free to read. You can still purchase the product to gain permanent access when it is no longer free.
                    </span>
                    {renderBuyButtonText('ADD TO CART', variant)}
                </div>);
            }
            return <></>;

        }

        return (
            <>
                <ReadOrPurchaseButton
                    product={product}
                    variant={variant}
                    showIfDisabled
                    className={'product-select-p-item-checkout-button'}
                    page={"Product"}
                />
                <AddToCartTextIfPurchasableAndNotPaid />
            </>
        );
    }

    function UpdatingCartOverlay() {
        const updatingCart = useAtomValue(UpdatingCartAtom);
        if(updatingCart) {
            return (
                <div className='product-select-p-item-process-container'>
                    <span className='product-select-p-item-process-title'>Processing...</span>
                </div>
            );
        }

        return null;
    }

    return (
        <div className={'select-product-item-container'}>
            <div className='product-select-p-item-container'>
                <UpdatingCartOverlay />
                <div className='product-select-p-item-info-price-wrapper'>

                    <div className='product-select-p-item-info-wrapper'>
                        <span className='product-select-p-item-info-title'>{title}</span>
                        <span className='product-select-p-item-info-text'>{text}</span>
                    </div>

                    <div className='product-select-p-item-price-wrapper'>
                        <PriceOrOwnershipStatus />
                    </div>

                </div>
                <div className={`product-select-p-item-checkout-wrapper ${variant.type === "Digital" && !isTheVolumeInCartDigital(cartAtom, product) && Variant.IsPurchaseable(variant) && "product-select-p-item-checkout-wrapper-new-state"}`}>
                    <PurchaseProductSection />
                </div>
                <div className='product-select-p-item-divider' />
                {/*{index <= length - 3 && <div className='product-select-p-item-divider' />}*/}
            </div>
        </div>
    );
};

export default SelectProductItem;